module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-p-1080-a282f6264212b28ba7c2038ac9dcc8b3.jpg";